'use client';

import { notify } from 'src/utils/notifications';
import SecretButton from './SecretButton';
import { useSyncLocalStorage } from 'src/hooks/useSyncLocalStorage';

type SecretDevModeToggleButtonProps = {
	children: React.ReactNode;
	className?: string;
};

export const SecretDevModeToggleButton = ({
	children,
	className,
}: SecretDevModeToggleButtonProps) => {
	const [devSwitchIsOn, setDevSwitchIsOn] = useSyncLocalStorage(
		'devswitch',
		false
	);

	return (
		<SecretButton
			onSecretActivate={() => {
				setDevSwitchIsOn(!devSwitchIsOn);

				notify({
					type: 'info',
					message: `Toggling devswitch ${devSwitchIsOn ? 'off' : 'on'}`,
				});
			}}
			className={className}
		>
			{children}
		</SecretButton>
	);
};
